class BESSAppTooltip extends BESSAppComponent {

    static active = null;

    static close() {
        if (BESSAppTooltip.active != null) {
            BESSAppTooltip.active.popover('hide');
        }
    }

    constructor() {
        super('.app-tooltip');
    }

    static remove(node) {
        node.popover('dispose');

    }

    static update(node, content) {
        node.popover('dispose');
        node.find('.content').remove();
        node.append('<div class="content hidden"></div>');
        node.find('.content ').html(content);
        new BESSAppTooltip().setupComponent(node);
    }

    setupComponent(tooltip) {
        let content = tooltip.find('.content');
        let contentSelector = tooltip.data('content');
        let trigger = 'focus hover';
        if (tooltip.data('trigger') !== undefined) {
            trigger = tooltip.data('trigger');
        }

        if (contentSelector !== undefined) {
            content = $(contentSelector);
            if(trigger !== 'click') {
                if(contentSelector[0] == '#') {
                    tooltip.attr('aria-labelledby', contentSelector.substring(1));
                }
            }
        } else {
            if(trigger !== 'click') {
                tooltip.attr('aria-label', content.text());
            }
        }


        BESSAppComponent.initialiseFor(content);

        let popoverClass = tooltip.data('popover-class');
        if (popoverClass === undefined) {
            popoverClass = 'app-popover';
        }
        let placement = tooltip.data('placement');
        if (placement === undefined) {
            placement = "top";
        }
        if (content.length === 0) {
            return;
        }

        tooltip.popover({
            html: true,
            container: 'body',
            trigger: trigger,
            //trigger: 'click',
            placement: placement,
            content: content.html(),
            sanitize: false,
            customClass: popoverClass,
        });

        if(!tooltip.attr('role')) {
            if(trigger !== 'click') {
                tooltip.attr('role', 'tooltip');
            } else {
                tooltip.attr('role', 'button');
            }
        }

        tooltip.off('shown.bs.popover').off('hidden.bs.popover');
        tooltip.on('shown.bs.popover', function () {
            BESSAppTooltip.close();
            BESSAppTooltip.active = tooltip;
        });
        tooltip.on('hidden.bs.popover', function () {
            BESSAppTooltip.active = null;
        });

        content

    }
}